/* eslint-disable max-len */
import React, { useCallback, useState } from 'react';
import { Host } from '../../../Host';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ClipDataBuilder, ClipboardService } from '../../../platform/Clipboard';
import { Menu } from '../../../ui';
import { DropMenuButton } from '../../../ui/MenuButton';
import { useResolve } from '../../Container';
import { usePermissionCheck } from '../../common/PermissionElements';
import { folderDelete, folderRename } from '../../workspace/FolderCommands';
import { FolderModel } from '../Models';
import { Flexer } from './LayoutElements';

export const FolderActionMenu = React.memo<{ folder: FolderModel }>(({ folder, }) => {

    const clipboard = useResolve(ClipboardService);
    const dispatch = useResolve(CommandDispatcher);
    const [open, setOpen] = useState(false);
    const canEdit = usePermissionCheck('da:write', 'wo:write');

    const onCopyLink = useCallback(() => {
        const data = new ClipDataBuilder();
        data.setText(Host.absUrl(folder.path || folder.id));
        clipboard.write(data.build());
    }, [folder.id]);

    const close = () => {
        setOpen(false);
        return true;
    };

    return <DropMenuButton icon="deqo://icons/hero/dots-horizontal" open={open} setOpen={setOpen}>
        <Flexer minWidth="10">
            <Menu>
                <Menu.Item onClick={() => close() && onCopyLink()}>
                    <Menu.ItemText>Copy Link</Menu.ItemText>
                </Menu.Item>
                <Menu.Divide />
                <Menu.Item disabled={!canEdit} onClick={() => close() && dispatch(folderRename, [folder.id])}>
                    <Menu.ItemText>Rename</Menu.ItemText>
                </Menu.Item>
                <Menu.Item disabled={!canEdit} onClick={() => close() && dispatch(folderDelete, [folder.id])}>
                    <Menu.ItemText>Delete</Menu.ItemText>
                </Menu.Item>
            </Menu>
        </Flexer>
    </DropMenuButton>;
});
